export const ALT_DOMAIN = 'alfaonline.org';
